import {TranslateService} from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import {Injectable} from '@angular/core';


/* https://github.com/angular/material2/issues/5573#issuecomment-358305725  */
@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    private itemsPerPageKey = 'generic.items_per_page';
    constructor(private translate: TranslateService) {
        super();

        this.translate.onLangChange.subscribe((e: Event) => {
            this.getAndInitTranslations();
        });

        this.getAndInitTranslations();
    }

    setItemsPerPageKey(key: string) {
        this.itemsPerPageKey = key;
        this.getAndInitTranslations();
    }

    getAndInitTranslations() {
        this.translate.get(this.itemsPerPageKey).subscribe((res: string) => {
            console.log(res);
            this.itemsPerPageLabel = res;
            this.changes.next();
        });
    }

    getRangeLabel = (page: number, pageSize: number, length: number) =>  {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} / ${length}`;
    }
}